import React from 'react';

const Testimonial = () => {
  return (
    <>
      <div className="modify-card-testimonial">
        <p className="quote">
          “The Information has turned out to be incredibly worth the price tag, if you&apos;re into
          tech news. Really solid stuff I look forward to.”
        </p>
        <div className="attr">
          <img src="/images/testimonial-sullivan-sm.png" alt="Danny Sullivan" />
          <span className="name">Danny Sullivan</span>
        </div>
      </div>
      <div className="modify-card-testimonial">
        <p className="quote">
          &ldquo;The Information is, for sure, the most thoughtful / smartest tech coverage.&rdquo;
        </p>
        <div className="attr">
          <img src="/images/testimonial-altman-270-sq.png" alt="Sam Altman" />
          <span className="name">Sam Altman</span>
        </div>
      </div>
    </>
  );
};

export default Testimonial;
